<template>
  <div class="page-container">
	<v-toolbar color="secondary" dark class="headline">
    	<v-toolbar-title>Caracteres</v-toolbar-title>
	</v-toolbar>
	<v-container fluid>
        <v-layout row wrap>
			<v-flex xs12 sm4 pa-1 v-for="caracter in caracteres" :key="caracter.id">
				<v-card>
				<v-container fluid grid-list-lg>
					<v-layout row wrap>
					<v-flex xs12>
						<div v-if="caracter.editando!=true" class="headline caracteres-titulo" >{{caracter.descripcion}}</div>
						<v-text-field :id="'txtCaracter' + caracter.id" class="headline input-caracteres"  v-if="caracter.editando==true" v-model="caracter.descripcion"></v-text-field>
						<v-card-actions style="padding:0px;margin-top: 10px;justify-content:flex-end">
							<v-btn fab v-if="caracter.editando==true" style="margin-right:10px!important" color="red" dark @click="cancelar(caracter)"><v-icon class="fa-fab-icon">fa-times</v-icon></v-btn>
							<v-btn fab v-if="caracter.editando==true" color="green" dark @click="aceptar(caracter)"><v-icon class="fa-fab-icon">fa-check</v-icon></v-btn>
							<v-btn fab v-if="caracter.editando!=true" style="margin-right:10px!important" :disabled="editando" color="red" dark @click="confirmarEliminar(caracter)"><v-icon class="fa-fab-icon">fa-trash</v-icon></v-btn>
							<v-btn fab v-if="caracter.editando!=true" :disabled="editando" color="blue" dark @click="setEditando(caracter)"><v-icon class="fa-fab-icon">fa-pen</v-icon></v-btn>
						</v-card-actions>
					</v-flex>
					</v-layout>
				</v-container>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
	<v-btn color="green" :disabled="editando" dark fixed bottom right class="btn-very-large" @click="agregarNuevo()" fab>
		<v-icon>add</v-icon>
    </v-btn>
	<v-snackbar top :color="snackCaracter" v-model="snackbar">{{ mensaje }}<v-btn color="black" small fab dark @click="snackbar = false"><v-icon class="fa-fab-icon">fa-times</v-icon></v-btn>
    </v-snackbar>
	<v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Eliminar Caracter</span>
        </v-card-title>
        <v-card-text>
			¿Estás seguro que querés eliminar el caracter?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="onCancelarEliminar()">No</v-btn>
          <v-btn color="blue darken-1" dark @click="onConfirmarEliminar()">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  	<div style="height:80px;width:1px;" v-if="$vuetify.breakpoint.smAndDown">&nbsp;</div>
  </div>
</template>

<script>
export default {
  name: "caracteres",
  components: {},
  data() {
    return { caracteres: [],snackbar:false,mensaje:'',snackCaracter:'success',editando:false,dialog:false,aEliminar:null};
  },
  created() {
    this.obtenerElementos();
  },
  methods: {
    obtenerElementos: function() {
		this.$http.get(this.$root.mainUrl + 'api/caracteres.php').then(result => {
			result.json().then(elem =>{
				this.caracteres = elem;
				for(let i=0;i<this.caracteres.length;i++){
					this.$set(this.caracteres[i], 'editando', false);
				}
      		});
      	}, error => {
			//   console.error(error);
			this.showMessage('Ocurrió un error al obtener los caracteres','error');
      	});
	},
	setEditando: function(caracter){
		caracter.descripcionBack = caracter.descripcion;
		caracter.editando = true;
		this.editando = true;
		this.$nextTick(() => document.getElementById('txtCaracter' + caracter.id).focus());
	},
	cancelar: function(caracter){
		caracter.descripcion = caracter.descripcionBack;
		caracter.editando = false;
		this.editando = false;
		if (caracter.id==null){
			this.caracteres.pop();
		}
	},
	confirmarEliminar: function(caracter){
		this.aEliminar = caracter;
		this.dialog = true;
	},
	onConfirmarEliminar: function(){
		this.dialog = false;
		this.eliminar(this.aEliminar);
	},
	onCancelarEliminar: function(){
		this.dialog = false;
		this.aEliminar = null;
	},
	eliminar: function(caracter){
		caracter.operacion = "ELIMINAR";
		this.$http.post(this.$root.mainUrl + 'api/caracteres.php',caracter).then(result => {
			result.json().then(elem =>{
				let idx=this.getIndex(caracter);
				this.caracteres.splice(idx, 1);
				this.snackbar = true;
				this.mensaje = "Caracter eliminado correctamente";
				this.aEliminar = null;
			});
		}, error => {
			this.showMessage('Ocurrió un error al eliminar el caracter','error');
			// console.error(error);
		});
	},
	aceptar: function(caracter){
		if (caracter.descripcion==null || caracter.descripcion.trim()==''){
			this.showMessage('La descripción no puede estar vacía','error');
			return;
		}
		caracter.descripcionBack = null;
		caracter.editando = false;
		caracter.operacion = "GUARDAR";
		this.$http.post(this.$root.mainUrl + 'api/caracteres.php',caracter).then(result => {
			result.json().then(elem =>{
				if (elem.id!=null){
					caracter.id=elem.id;
					this.showMessage('Caracter creado correctamente','success');
				}
				else{
					this.showMessage('Caracter actualizado correctamente','success');
				}
				this.editando = false;
			});
		}, error => {
			this.showMessage('Ocurrió un error al actualizar el caracter','error');
			// console.error(error);
		});
	},
	agregarNuevo: function(){
		this.editando = true;
		let caracter = {editando:true,descripcion:'',id:null};
		this.caracteres.push(caracter);
		this.$vuetify.goTo(5000);
	},
	getIndex: function(caracter){
		for (let i=0;i<this.caracteres.length;i++){
			if (this.caracteres[i].id==caracter.id){
				return i;
			}
		}
		return -1;
	},
	showMessage: function(message,style){
		this.snackCaracter = style;
		this.mensaje = message;
		this.snackbar = true;
	}
  }
};
</script>
<style>
.page-container{
	padding-top:60px;
}
.fa-fab-icon{
	font-size: 1.5em!important;
}
.btn-very-large{
	height: 66px!important;
	width: 66px!important;
}
.btn-very-large i{
	font-size: 3.5em!important;
}
.caracteres-titulo{
	min-height:40px;
}
.input-caracteres{
	padding-top: 0px!important;
	padding-bottom: 0px!important;
	margin-top: 0px!important;
	margin-bottom: 0px!important;
}
.input-caracteres .v-text-field__details{
	display: none;
}
</style>
